import React from 'react';

import { checkFeatureGate } from '../../../utilities/feature-flags/feature-gate';
import { AidFrontendFeatureGate } from '../../../providers/FeatureGates';
import PasskeyLoginPanel from '../../../components/PasskeyLoginPanel';
import { getCurrentCloudType } from '../../../utilities/env';

type Props = {
  onPasskeyLogin: () => void;
  authenticating?: boolean;
};

const MaybePasskeyLoginPanel = ({ onPasskeyLogin, authenticating }: Props) => {
  const isPasskeyAuthEnabled = checkFeatureGate(AidFrontendFeatureGate.ENABLE_PASSKEY_AUTH);
  const isCommercial = getCurrentCloudType() === 'commercial';

  if (!isPasskeyAuthEnabled || !isCommercial) {
    return null;
  }

  return <PasskeyLoginPanel handlePasskeyLogin={onPasskeyLogin} authenticating={authenticating} />;
};

export default MaybePasskeyLoginPanel;
